import { Alert, Input, message, Tabs } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormButtons } from '../../../../../lib/components/Form/FormButtons';
import { FormContainer } from '../../../../../lib/components/Form/FormContainer';
import { FormField } from '../../../../../lib/components/Form/FormField';
import { UploaderPDF } from '../../../../../lib/components/UploaderPDF';
import { useRequestFeedback } from '../../../../../lib/hooks';
import { InformativeEntity, SignedUrlTypes } from '../../../../../lib/model/Informative';
import { InformativeInsertDto } from '../../dto/InformativeInsertDto';
import { InformativeUpdateDto } from '../../dto/InformativeUpdateDto';
import { useInformativesApi } from '../../hooks/useInformativesApi';
import { useInformativeForm } from './useInformativeForm';
import { FilePdfOutlined } from '@ant-design/icons';
import { createBrowserHistory } from 'history';
import { DateInput } from '../../../../../lib/components/DateInput';
import moment from 'moment';

const class_name_field = 'w-1/2';

interface IProps {
	informative?: InformativeEntity;
	on_change_form?: () => void;
}

export const InformativeForm: FC<IProps> = ({ informative, on_change_form }) => {
	const history = createBrowserHistory();
	const navigate = useNavigate();
	const { TabPane } = Tabs;
	const { id: num_id, type: type } = useParams() as { id: string; type: string };
	const BASE_URL = `${process.env.REACT_APP_INFORMATIVE_API}/informatives/${num_id}/pdf`;

	const { form_state, show_errors, change_field_value, fill_with_data } = useInformativeForm();

	const { insert, update, get_last_informative_id, get_informative_by_date } = useInformativesApi();

	function submit() {
		show_errors();
		const dto: InformativeUpdateDto | InformativeInsertDto = {
			...form_state.value,
			publish_date: moment(form_state.value.publish_date).format('YYYY-MM-DD'),
			num_id: moment(form_state.value.publish_date).format('YYYY-MM-DD'),
			type: 'jacoby',
			is_published: false,
			filter_month_year: moment(form_state.value.publish_date).format('MM-YYYY'),
		};

		if (!form_state.valid) {
			return;
		}
		return informative ? update.do_update(dto) : insert.create(dto);
	}

	function validate_is_exists_informative_by_date() {
		get_informative_by_date.get(moment(form_state.value.publish_date).format('YYYY-MM-DD'));
	}

	var isExistsInformativeBydate = false;
	useEffect(() => {
		const res = get_informative_by_date.result || {};
		if (res.num_id) {
			isExistsInformativeBydate = true;
			message.warning(
				'Já existe um informativo cadastrado para a data selecionada. Selecione outra data ou exclua o informativo existente, e cadastre novamente!'
			);
			//window.location.reload();
		}
	}, [get_informative_by_date.result]);

	useEffect(() => {
		const res = get_informative_by_date.result || {};
		if (res.num_id) {
			isExistsInformativeBydate = true;
			message.warning(
				'Já existe um informativo cadastrado para a data selecionada. Selecione outra data ou exclua o informativo existente, e cadastre novamente!'
			);
			//window.location.reload();
		}
	}, [get_informative_by_date.result]);

	useEffect(() => {
		if (update.result || insert.result) {
			message.success('Salvo com sucesso.');
			const num_id = update.result?.num_id || insert.result?.num_id;
			history.push(`/conteudos/informativos/jacoby/list/${num_id}`);
			window.location.reload();
		}
	}, [update.result, insert.result]);

	useEffect(() => {
		validate_is_exists_informative_by_date();
	}, [form_state.value.publish_date]);

	const convert_date_string_to_timestamp = (date: string) => {
		return Date.parse(date) + 90000000;
	};

	useRequestFeedback(update.result, update.error);
	useRequestFeedback(insert.result, insert.error);

	return (
		<Tabs type='card'>
			<TabPane tab='Informações' key='infos'>
				<FormContainer>
					{informative ? (
						<>
							<Alert
								message={`É necessário republicar a edição para que as alterações reflitam na plataforma.`}
								type='warning'
							/>
							<br />
						</>
					) : (
						<></>
					)}

					<FormField
						{...{
							label: 'Data de Publicacao',
							name: 'publish_date',
							form_state,
							required: true,

							children: (
								<DateInput
									{...{
										disabled: !!informative,
										key: informative?.num_id,
										date: new Date(form_state.value.publish_date),
										on_changed: (date) => {
											change_field_value('publish_date', convert_date_string_to_timestamp(date));
										},
									}}
								/>
							),
						}}
					/>

					<FormField {...{ label: 'ID', name: 'num_id', form_state }}>
						<Input
							value={moment(form_state.value.publish_date).format('YYYY-MM-DD')}
							type={'text'}
							className={class_name_field}
							disabled={true}
						/>
					</FormField>

					<FormButtons
						{...{
							disabled: false,
							on_update_button_click: informative ? submit : undefined,
							go_back_on_cancel: true,
							on_add_button_click: !informative ? submit : undefined,
						}}
					/>
					{informative ? (
						<>
							<FormField {...{ label: 'PDF', name: 'pdf', form_state }}>
								<UploaderPDF
									{...{
										on_success: () => {
											message.success('Documento salvo com sucesso.');
											if (on_change_form) on_change_form();
										},
										upload_api_endpoint: `${BASE_URL}/${SignedUrlTypes.WRITE}`,
									}}
								/>
							</FormField>
							{informative.pdf && (
								<FormField {...{ label: 'Download', name: 'key', required: false, form_state }}>
									<a href={informative.pdf} target='_blank' className='block mt-2 mb-1'>
										<div className='flex items-center'>
											<FilePdfOutlined style={{ marginRight: '0.3rem' }} />{' '}
											{String(informative.pdf).split('/')[3]}
										</div>
									</a>
								</FormField>
							)}
						</>
					) : (
						<div className='block'>
							Por favor, salve os dados iniciais antes de realizar o upload de um PDF.
						</div>
					)}
				</FormContainer>
			</TabPane>
		</Tabs>
	);
};
